
export default function Services() {
  return (
    <section id="services" className="relative py-12 sm:py-20 bg-black text-white">
      <div className="absolute inset-0">
        <img 
          src="https://static.wixstatic.com/media/87f369_a1c7315dd315425d9b1ba89999a2a709~mv2.jpeg/v1/fill/w_1920,h_600,fp_0.50_0.50,q_85,enc_avif,quality_auto/342DE80D-9DB7-4388-BB83-C3462A282C52.jpeg"
          alt="Service Background"
          className="w-full h-full object-cover opacity-40"
        />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 text-center">
        <h2 className="text-2xl sm:text-4xl font-bold">Service of cleaning</h2>
      </div>
    </section>
  );
}
